var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrencyRupeeIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#444444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M542.08-160 300-412.31v-52.31h120q60.69 0 110.35-38.34 49.65-38.35 50.73-109.35H260v-40h316.77q-12.39-47.31-55.5-77.5Q478.15-760 420-760H260v-40h440v40H542.31q28.61 17 49.61 45.85 21 28.84 26.23 61.84H700v40h-78.69q-.31 85-60.77 136.35-60.46 51.34-140.54 51.34h-75.92L597.69-160h-55.61Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyRupeeIc);
export default __webpack_public_path__ + "static/media/currency_rupee_ic.cab0016dfe6025f4fe97b6842b16a739.svg";
export { ForwardRef as ReactComponent };